"use client";

import { UserWrapper } from "~/contexts/UserContext";
import { api } from "~/utils/api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionProvider } from "@golf-district/auth/nextjs-exports";
import { type EntityType } from "@golf-district/shared";
import { AppWrapper } from "~/contexts/AppContext";
import { CustomThemeProvider } from "~/contexts/CustomThemeContext";
import { CircleChecked } from "~/components/icons/CircleChecked";
import { ErrorIcon } from "~/components/icons/ErrorIcon";
import { InfoIcon } from "~/components/icons/InfoIcon";

function TRPCReactProvider(props: {
  children: React.ReactNode;
  entityData: EntityType | undefined;
  headers?: Headers;
}) {
  return (
    <SessionProvider>
      <AppWrapper entityData={props.entityData}>
        <CustomThemeProvider>
          <UserWrapper>
            {props.children}
            <ToastContainer
              position="top-right"
              autoClose={9000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              icon={({ type }) => {
                switch (type) {
                  case "success":
                    return <CircleChecked fill="var(--primary-color)" />;
                  case "error":
                    return <ErrorIcon />;
                  case "info":
                    return <InfoIcon />;
                  default:
                    return null;
                }
              }}
            />
          </UserWrapper>
        </CustomThemeProvider>
      </AppWrapper>
    </SessionProvider>
  );
}

export default api.withTRPC(TRPCReactProvider) as typeof TRPCReactProvider;
